export default function initCopy() {

  // Get all elements with the class "js-copy"
  var copyButtons = document.querySelectorAll('.js-copy');

  // Function to handle the copy action
  async function copyToClipboard(text, button) {
      try {
          await navigator.clipboard.writeText(text);

          // Show the "Copied." message
          let feedbackSpan = button.querySelector('.icon-wrapper');
          feedbackSpan.classList.toggle('animate');

      } catch (err) {
          
      }
  }

  // Add click event listener to each button
  copyButtons.forEach(function(button) {
      button.addEventListener('click', function() {
          var contentToCopy = button.getAttribute('data-copy-content');
          if (contentToCopy) {
              copyToClipboard(contentToCopy, button); // Passing button as an argument
          }
      });
  });

}
